import { useState, useEffect, useCallback } from "react";

const ALUMNI_RE_ENROLMENT_DEFAULT_STATE = {
    step: 0,
    divisionSelected: null,
    yearGroupSelected: null,
    startDateSelected: null,
    packageSelected: null,
    subjectsSelected: [],
};

export const useAlumniReEnrolmentStorage = (activeStudentId) => {
    const storageKey = activeStudentId ? `alumni_re_enrolment_${activeStudentId}` : null;

    const [summaryText, setSummaryText] = useState("");
    const [mode, setMode] = useState("selection");
    const [state, setState] = useState(() => {
        if (!storageKey) return ALUMNI_RE_ENROLMENT_DEFAULT_STATE;
        try {
            const stored = localStorage.getItem(storageKey);
            return stored ? JSON.parse(stored) : ALUMNI_RE_ENROLMENT_DEFAULT_STATE;
        } catch {
            return ALUMNI_RE_ENROLMENT_DEFAULT_STATE;
        }
    });

    useEffect(() => {
        if (!storageKey) return;
        try {
            const stored = localStorage.getItem(storageKey);
            setState(stored ? JSON.parse(stored) : ALUMNI_RE_ENROLMENT_DEFAULT_STATE);
        } catch {
            setState(ALUMNI_RE_ENROLMENT_DEFAULT_STATE);
        }
    }, [storageKey]);

    useEffect(() => {
        if (!storageKey) return;
        try {
            localStorage.setItem(storageKey, JSON.stringify(state));
        } catch {
        }
    }, [storageKey, state]);

    const setField = useCallback((field) => (value) => {
        setState((prev) => ({ ...prev, [field]: value }));
    }, []);

    const clearAlumniReEnrolmentStorage = useCallback(() => {
        if (!storageKey) return;
        localStorage.removeItem(storageKey);
        setState(ALUMNI_RE_ENROLMENT_DEFAULT_STATE);
    }, [storageKey]);

    const hasAlumniReEnrolmentData = Boolean(
        state.divisionSelected
        || state.yearGroupSelected
        || state.startDateSelected
        || state.packageSelected
        || state.subjectsSelected.length > 0,
    );

    return {
        step: state.step,
        divisionSelected: state.divisionSelected,
        yearGroupSelected: state.yearGroupSelected,
        startDateSelected: state.startDateSelected,
        packageSelected: state.packageSelected,
        subjectsSelected: state.subjectsSelected,

        setStep: setField("step"),
        setDivisionSelected: setField("divisionSelected"),
        setYearGroupSelected: setField("yearGroupSelected"),
        setStartDateSelected: setField("startDateSelected"),
        setPackageSelected: setField("packageSelected"),
        setSubjectsSelected: setField("subjectsSelected"),

        summaryText,
        setSummaryText,
        mode,
        setMode,
        hasAlumniReEnrolmentData,
        clearAlumniReEnrolmentStorage,
    };
};
